export default __webpack_public_path__ + "images/43d3f46ad94ba81da732ad1a78a7a42f-1_4K_1920x544.webp";